export enum PREFERRED_UNIT {
  LBTC = 'BTC',
  mBTC = 'mBTC',
  uBTC = 'Bits',
  SAT = 'Sats',
}
